import { Button, Form, Modal } from 'antd';
import { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';

import style from './ShowTour.module.css';

import { serviceBundler } from '../../../../App';
import { useNavigate } from 'react-router-dom';

import {
  HomeOutlined,
  TabletOutlined,
  SettingOutlined,
  KeyOutlined,
} from '@ant-design/icons';

export function ShowTour(props: { open: boolean; onCancel: Function }) {
  const navigate = useNavigate();

  const { i18n, t } = useTranslation();

  useEffect(() => {
    serviceBundler.tourService.TourStart.subscribe((value) => {
      if (value) {
        props.onCancel();
      }
    });
  }, [0]);

  const handleCancel = () => {
    serviceBundler.tourService.EndAllTours();
    props.onCancel();
  };

  const StartAllTours = () => {
    CloseTourModal();
    navigate('/home');

    serviceBundler.tourService.EndAllTours();
  };

  const StartHomePageTour = () => {
    CloseTourModal();

    navigate('/home');

    serviceBundler.tourService.StartHomePageTour();
  };

  const StartLoginPageTour = () => {
    CloseTourModal();
    navigate('/login');

    serviceBundler.tourService.StartLoginPageTour();
  };

  const StartDevicesPageTour = () => {
    CloseTourModal();
    navigate('/devices');

    serviceBundler.tourService.StartDevicesPageTour();
  };

  const StartSettingsPageTour = () => {
    CloseTourModal();
    navigate('/settings');

    serviceBundler.tourService.StartSettingsPageTour();
  };

  const CloseTourModal = () => {
    props.onCancel();
  };

  return (
    <div style={{ zIndex: 10000 }}>
      <Modal
        title={t('tour')}
        open={props.open}
        onCancel={handleCancel}
        footer={[
          <Button key="back" onClick={() => handleCancel()}>
            {t('cancel')}
          </Button>,
          <Button key="start" onClick={() => StartAllTours()}>
            {'Start hele rondleiding'}{' '}
          </Button>,
        ]}
      >
        <div className={style.buttonRow} style={{ zIndex: 10000 }}>
          {t('tourWelcome1')}

          {'U kunt kiezen om de tour te starten of deze te annuleren.'}
          <br />
          {
            'Daarnaast kunt ook kiezen om alleen een specifieke tour te starten.'
          }

          <br />
          {
            'De tour is een korte uitleg over de belangrijkste onderdelen van de applicatie.'
          }

          <br />
          {'U kunt de tour op elk moment overslaan of annuleren.'}

          <Button
            icon={<HomeOutlined />}
            type="primary"
            onClick={() => StartHomePageTour()}
          >
            {'Start rondleiding home-pagina'}{' '}
          </Button>
          <Button
            icon={<KeyOutlined />}
            type="primary"
            onClick={() => StartLoginPageTour()}
          >
            {'Start rondleiding inlog-pagina'}{' '}
          </Button>
          <Button
            icon={<TabletOutlined />}
            type="primary"
            onClick={() => StartDevicesPageTour()}
          >
            {'Start rondleiding apparaten-pagina'}{' '}
          </Button>
          <Button
            icon={<SettingOutlined />}
            type="primary"
            onClick={() => StartSettingsPageTour()}
          >
            {'Start rondleiding instellingen-pagina'}{' '}
          </Button>

          <br />
          {
            'U kunt de toer later alsnog volgen door op de knop linksonder "Start rondleiding" te klikken'
          }
        </div>
      </Modal>
    </div>
  );
}
